import { useMutation } from "@apollo/client";
import { VerifyEmailMutation, VerifyEmailMutationVariables } from "@ctypes";
import { VERIFY_EMAIL } from "@graphql";

export const useVerifyEmail = () => {
  return useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VERIFY_EMAIL);
};
